const TargetTitle = ({ record }) => {
    return <span>Target {record ? `"${record.name}"` : ''}</span>;
};

export default TargetTitle;